<div class="distribution-number-range-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <dx-popup #addDistributionNumberRange [width]="600" [showTitle]="true" title="{{ modalTitle }}" [dragEnabled]="false"
    [closeOnOutsideClick]="false" [rtlEnabled]="rtlEnabled" [(visible)]="isOpened"
    (onShown)="onFieldDataChanged($event)">
    <dx-scroll-view width="100%" height="100%">
      <div class="au-dx-popup-padder">
        <dx-form #distributionNumberRangeForm id="distributionNumberRangeForm" validationGroup="distributionNumberRangeData" [showValidationSummary]="false"
                 (onFieldDataChanged)="onFieldDataChanged($event)" colCount="auto" [(formData)]="model" [minColWidth]="500">

          <dxi-item itemType="group">

            <dxi-item dataField="masterDataListRowId"
                        editorType="dxSelectBox"
                        [editorOptions]="{ dataSource: masterDataLookupSource, valueExpr:'value' ,
                      displayExpr:'label', searchEnabled: 'true', showClearButton: 'true', disabled: isEditMode}">
                <dxo-label text="{{ 'DISTRIBUTION_MANAGEMENT.CATEGORY' | translate }}"></dxo-label>
                <dxi-validation-rule type="required" message="{{ 'DISTRIBUTION_MANAGEMENT.CATEGORY' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="distributionNumberRangeType"
                  editorType="dxSelectBox"
                  [editorOptions]="{ 
                  dataSource: [
                    { value: 0, label: 'DISTRIBUTION_MANAGEMENT.FIXED' | translate },
                    { value: 1, label: 'DISTRIBUTION_MANAGEMENT.VARIABLE' | translate }
                  ], 
                  valueExpr: 'value', 
                  displayExpr: 'label', 
                  showClearButton: false,
                  disabled: isEditMode
                  }">
              <dxo-label text="{{ 'DISTRIBUTION_MANAGEMENT.DISTRIBUTION_NUMBER_TYPE' | translate }}"></dxo-label>
              <dxi-validation-rule type="required" message="{{ 'DISTRIBUTION_MANAGEMENT.DISTRIBUTION_NUMBER_TYPE' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
            </dxi-item>
            

            <dxi-item dataField="from" editorType="dxNumberBox" [editorOptions]="{ format: '#', min: 0, step: 1}">
              <dxo-label text="{{ 'DISTRIBUTION_MANAGEMENT.FROM' | translate }}"></dxo-label>
              <dxi-validation-rule type="required" message="{{ 'DISTRIBUTION_MANAGEMENT.FROM' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
              </dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="till" editorType="dxNumberBox" [editorOptions]="{ format: '#', min: 0, step: 1}">
              <dxo-label text="{{ 'DISTRIBUTION_MANAGEMENT.TILL' | translate }}"></dxo-label>
              <dxi-validation-rule type="required" message="{{ 'DISTRIBUTION_MANAGEMENT.TILL' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
              </dxi-validation-rule>
            </dxi-item>

          </dxi-item>
        </dx-form>
        <button type="submit" class="btn btn-primary" (click)="onSubmit();" name="btnDistributionNumberRangeSubmit"
        disabled="disabled">{{ 'SHARED.SAVE' | translate }}</button>
      <button type="button" class="btn btn-outline" (click)="onCancel();">{{ 'SHARED.CANCEL' | translate }}</button>
    
        </div>
    </dx-scroll-view>
  </dx-popup>
</div>
